import { FC } from 'react';

type CelebrationBannerProps = {
  emoji: string;
  headline: string;
  body?: string;
};

/**
 * The ahead-state celebration banner (spec 6.5): celebrate the lead
 * first, introduce the (true) threat second. First element on the race
 * verdict screen, ahead state only.
 */
const CelebrationBanner: FC<CelebrationBannerProps> = ({
  emoji,
  headline,
  body
}) => (
  <div
    className="flex items-start gap-3 rounded-xl border-2 border-success-400 bg-success-50 px-4 py-3"
    data-cy="readiness-celebration-banner"
  >
    <span className="text-xl" aria-hidden="true">
      {emoji}
    </span>
    <p className="font-body text-sm text-neutral-800">
      <span className="font-bold text-success-700">{headline}</span>
      {body && <span> {body}</span>}
    </p>
  </div>
);

export default CelebrationBanner;
